import { createFileRoute } from "@tanstack/react-router";
import BcbsmInsurance, { config } from "@/pages/BcbsmInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/bcbsm-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "BCBS Michigan TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Blue Cross Blue Shield Michigan coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "BCBS Michigan TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Blue Cross Blue Shield Michigan coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/bcbsm-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/bcbsm-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <BcbsmInsurance />;
}
